import apiService from './apiService';

class AntivirusService {

  async getStatistics() {
    return apiService.get('/api/av/statistics');
  }

  async getScans({ agent_id = null, limit = 50 } = {}) {
    let url = `/api/av/scans?limit=${limit}`;
    if (agent_id) url += `&agent_id=${agent_id}`;
    return apiService.get(url);
  }

  async getAgentScans() {
    return apiService.get('/api/av/agents');
  }

  async getScanDetail(scanId) {
    return apiService.get(`/api/av/scans/${scanId}`);
  }

  async getThreats({ agent_id = null, limit = 50 } = {}) {
    let url = `/api/av/threats?limit=${limit}`;
    if (agent_id) url += `&agent_id=${agent_id}`;
    return apiService.get(url);
  }

  async getAgents() {
    return apiService.get('/api/agents');
  }

  async triggerGlobalScan(scanType = 'quickscan') {
    try {
      const response = await apiService.post('/api/av/trigger-scan', {
        scan_type: scanType
      });
      if (!response.success) throw new Error(response.message || 'Failed to trigger scan');
      return response;
    } catch (error) {
      console.error('[AntivirusService] triggerGlobalScan failed:', error);
      throw error;
    }
  }

  // ── Schedule methods ──────────────────────────────
  async getSchedules() {
    return apiService.get('/api/av/schedules');
  }

  async createSchedule(data) {
    return apiService.post('/api/av/schedules', data);
  }

  async updateSchedule(id, data) {
    return apiService.put(`/api/av/schedules/${id}`, data);
  }

  async deleteSchedule(id) {
    return apiService.delete(`/api/av/schedules/${id}`);
  }
}

const antivirusService = new AntivirusService();
export default antivirusService;